// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your translation files
import translationEN from '../locales/en/translation.json';
import translationSV from '../locales/sv/translation.json';
import translationDK from '../locales/dk/translation.json';
import translationDE from '../locales/de/translation.json';
import translationIT from '../locales/it/translation.json';
import translationPT from '../locales/pt/translation.json';
import translationFR from '../locales/fr/translation.json';
import translationES from '../locales/es/translation.json';
import translationCN from '../locales/cn/translation.json';
import translationPL from '../locales/pl/translation.json';
import translationCZ from '../locales/cz/translation.json';
import translationHU from '../locales/hu/translation.json';
import translationEE from '../locales/ee/translation.json';
import translationFI from '../locales/fi/translation.json';

const resources = {
  en: { translation: translationEN },
  sv: { translation: translationSV },
  dk: { translation: translationDK },
  de: { translation: translationDE },
  it: { translation: translationIT },
  pt: { translation: translationPT },
  fr: { translation: translationFR },
  es: { translation: translationES },
  cn: { translation: translationCN },
  pl: { translation: translationPL },
  cz: { translation: translationCZ },
  hu: { translation: translationHU },
  ee: { translation: translationEE },
  fi: { translation: translationFI },
};

i18n
  .use(LanguageDetector) // Use the language detector
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // Default language
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'], // Cache the user's language in localStorage
    },
  });

export default i18n;
